// extracted by mini-css-extract-plugin
export var backgroundNeutral05 = "OfferHighlightCard-module--background-neutral05--1aae9";
export var backgroundWhite = "OfferHighlightCard-module--background-white--311f4";
export var content = "OfferHighlightCard-module--content--31e1d";
export var icon = "OfferHighlightCard-module--icon--e6ba1";
export var iconUrl = "OfferHighlightCard-module--icon-url--d1c76";
export var offer = "OfferHighlightCard-module--offer--f5f08";
export var title = "OfferHighlightCard-module--title--7b72a";